import { useNavigate } from 'react-router-dom';

export function MongoDB() {
  const navigate = useNavigate();

  // Data for platforms (image, title, and path)
  const platforms = [
    {
      title: 'Youtube Playlists',
      image: 'https://thumbs.dreamstime.com/b/high-resolution-colored-youtube-logo-white-background-vector-eps-file-available-additional-download-colored-youtube-logo-175730434.jpg',
      path: '/Backend_Mongo_Yt',
    },
    {
      title: 'Coursera',
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmVgLGfhr0DKM1D4bBSvZh9h6UdIG84qhbSsHAsn_P1KeOEa_wGqqbO9z1zcyn3atADVU&usqp=CAU',
      path: '/Backend_Mongo_Coursera',
    },
    {
      title: 'Udemy Courses',
      image: 'https://logowik.com/content/uploads/images/udemy-new-20212512.jpg',
      path: '/Backend_Mongo_Udemy',
    },
    {
      title: 'Geeks For Geeks',
      image: 'https://miro.medium.com/v2/resize:fit:799/0*yxCtOgS-v50Sqfzw.jpeg',
      path: '/Backend_Mongo_Gfg',
    },
    {
      title: 'Coding Platforms',
      image: 'https://img.freepik.com/premium-vector/continuous-line-building-city-logo-design_15473-14266.jpg?semt=ais_hybrid',
      path: '/Backend_Mongo_Codplat',
    },
  ];

  // Navigate function
  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <h1 className="html_head">Links are below</h1>
      <p className="html_para">
        These are the platforms for your <strong>MongoDB</strong> study purpose. Utilize these recommended platforms to explore and gain knowledge for practice.
      </p>

      <h3 className="reco_html">Recommended Platforms</h3>

      {/* Map through platforms array and render each platform */}
      {platforms.map((platform, index) => (
        <div className="container_html_pg" key={index}>
          <img className="html_logo_yt" style={{ height: '90px', width: '90px' }} src={platform.image} alt={platform.title} />
          <h5 style={{ margin: '30px 0px 0px 30px', fontFamily: 'Arial', fontWeight: 'bold' }}>
            {platform.title} &#9754;
          </h5>
          <div className="butt_yt">
            <button className="btn_html_yt" onClick={() => handleNavigation(platform.path)}>
              Click Me
            </button>
          </div>
        </div>
      ))}
    </>
  );
}

export default MongoDB;
